"use client";
import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useParams } from "react-router";
import ReadMore from "@/components/ReadMore";
import WalkthroughVideo from "@/components/Walkthrough";
import "./Detail.css";
import { Swiper, SwiperSlide } from "swiper/react";
import api from "@/helper/api.interceptor";
import { useDispatch, useSelector } from "react-redux";
import {
  setAmenityToggle,
  setInquiryPopup,
  setInquiryPopupObj,
  setThankYouData,
  setProximityToggle,
} from "@/store/slices/inquirySlice";
import { usePathname, useRouter } from "next/navigation";
import { Toast } from "@/components/Toast";
import RawData from "@/data/projectList.json";
import Image from "next/image";
// import BottomStrip from "@/components/BottomStrip";
// import { Fancybox } from "@fancyapps/ui";
// import Seo from "../components/Seo";
// import { CountryList } from "../services/CountryList";
// import { ProjectInquiry } from "../services/ProjectInquiry";

export default function Detail({
  //   isAmenityOpen,
  //   setAmenityToggle,
  //   isProximityOpen,
  //   setProximityToggle,
  // inquiryPopupObj,
  // setInquiryPopupObj,
  // inquiryPopup,
  // setInquiryPopup,
  projectDetail,
  propertylist,
  completedPropertylist,
}) {
  const pathName = usePathname();
  const dispatch = useDispatch();
  const router = useRouter();

  // const [isAmenityOpen, setAmenityToggle] = useState(false);
  // const [isProximityOpen, setProximityToggle] = useState(false);
  //   const { slug } = useParams();
  //   const navigate = useNavigate();
  const [staticProjectDetail, setStaticprojectDetail] = useState(null);
  // const [seoMetaData, setseoMetaData] = useState(null);
  // const [countryList, setcountryList] = useState(null);
  const [countryFlag, setCountryFlag] = useState(false);
  const [isMobilescreen, setMobileScreen] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [selectedTab, setSelectedTab] = useState("3bhk");
  const [showNextImages, setShowNextImages] = useState(false);
  const [search, setSearch] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [submitLoad, setSubmitLoad] = useState(false);
  // const [seoMetaData, setSeoMetaData] = useState(null);
  const [inquiryObj, setInquiryObj] = useState({
    agree_tandc: "1",
    agree_tandc_display: true,
    client_name: "",
    client_contact_no_display: "",
    client_contact_no: "",
    email_address: "",
    from_app: "true",
    master_user_id: "373",
    logged_in_master_user_id: "373",
    remarks: "",
    inquiry_from: "web",
    user_type: "N",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
    project_id: "",
  });
  const [errors, setErrors] = useState({});

  const StaticData = RawData.list;

  // const initialInquiryState = {
  //   agree_tandc: "1",
  //   agree_tandc_display: true,
  //   client_name: "",
  //   client_contact_no_display: "",
  //   client_contact_no: "",
  //   email_address: "",
  //   from_app: "true",
  //   master_user_id: "373",
  //   logged_in_master_user_id: "373",
  //   remarks: "",
  //   inquiry_from: "web",
  //   user_type: "N",
  //   flag: "https://flagcdn.com/w40/in.webp",
  //   country: "91",
  //   project_id: "",
  // };

  // function inquiryReducer(state, action) {
  //   switch (action.type) {
  //     case "UPDATE_FIELD":
  //       return { ...state, [action.field]: action.value };
  //     case "RESET":
  //       return initialInquiryState;
  //     case "SET_FULL_OBJECT":
  //       return { ...state, ...action.payload };
  //     default:
  //       return state;
  //   }
  // }

  // use it inside your component
  // const [inquiryObj, dispatchInquiry] = useReducer(
  //   inquiryReducer,
  //   initialInquiryState
  // );

  const countryList = useSelector((state) => state.inquiry.countryList);
  const isAmenityOpen = useSelector((state) => state.inquiry.isAmenityOpen);
  const isProximityOpen = useSelector((state) => state.inquiry.isProximityOpen);

  // ✅ Compute SEO data during render (SSR-friendly)
  //   const seoMetaData = projectDetail && {
  //     page_title: projectDetail.page_title || projectDetail.project_title,
  //     page_description: projectDetail.page_description,
  //     page_keywords: projectDetail.page_keywords,
  //     slug: projectDetail.slug,
  //     image: projectDetail.page_image_full
  //       ? projectDetail.page_image_full.includes("?")
  //         ? `${projectDetail.page_image_full}&w=1280&h=640`
  //         : `${projectDetail.page_image_full}?w=1280&h=640`
  //       : "/images/sswati-procon.png",
  //   };

  // const handleNumber = (e) => {
  //   const { name, value } = e.target;

  //   if (name == "client_contact_no_display") {
  //     const updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10); // ✅ keep only numbers and limit to 10 digits
  //     setInquiryObj((prev) => ({
  //       ...prev,
  //       [name]: updatedValue,
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    setFormSubmitted(false);
    const { name, value } = e.target;

    let updatedValue = value;

    // Prevent numbers in client_name (handle paste or typing)
    if (name === "client_name") {
      updatedValue = value.replace(/[0-9]/g, ""); // remove any digits
    }

    // For contact_no, allow only numbers
    if (name === "client_contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, ""); // remove non-numeric chars
      if (updatedValue.length > 10) {
        updatedValue = updatedValue.slice(0, 10); // limit to 10 digits
      }
    }

    // Email validation
    if (name === "email_address") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email_address: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email_address: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // Update state
    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   dispatchInquiry({ type: "UPDATE_FIELD", field: name, value });
  // };

  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.client_name.trim()) {
      newErrors.client_name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.client_name)) {
      newErrors.client_name = "Name must contain only letters";
    }

    if (!inquiryObj.client_contact_no_display.trim()) {
      newErrors.client_contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.client_contact_no_display)) {
      newErrors.client_contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email_address.trim()) {
      newErrors.email_address = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.group("FORM SUBMIT DEBUG");
    console.time("Submit Process");

    try {
      setFormSubmitted(true);

      const validationErrors = validate();

      if (Object.keys(validationErrors).length > 0) {
        console.error("3. Validation Failed");

        setErrors(validationErrors);

        console.groupEnd();
        console.timeEnd("Submit Process");

        return;
      }

      setSubmitLoad(true);

      let project_id = projectDetail.project_id;

      let client_contact_no =
        inquiryObj.country + " " + inquiryObj.client_contact_no_display;

      const finalInquiry = {
        ...inquiryObj,
        client_contact_no,
        project_id,
      };

      const response = await api.Projectinquiry(finalInquiry);

      if (!response?.success) {
        console.error("7. API Success False");

        setSubmitLoad(false);

        console.groupEnd();
        console.timeEnd("Submit Process");

        return;
      }

      // =========================
      // FACEBOOK PIXEL DEBUG
      // =========================

      if (typeof window !== "undefined" && typeof fbq === "function") {
        const leadPayload = {
          content_name: projectDetail.project_title,
          content_category: "Enquiry",
          value: 0,
          currency: "INR",
          customer_name: inquiryObj.client_name,
          customer_email: inquiryObj.email_address,
          customer_phone: client_contact_no,
          project_name: projectDetail.project_title,
          comments: inquiryObj.remarks,
        };

        fbq("track", "Lead", leadPayload);

        fbq("trackCustom", "FormSubmit", {
          form_name: "Contact Form",
          project_name: projectDetail.project_title,
          customer_name: inquiryObj.client_name,
        });

        // Verify Pixel Request
      } else {
        console.error("10. FBQ NOT FOUND");
        console.error("window.fbq:", window.fbq);
      }

      // =========================
      // SUCCESS FLOW
      // =========================

      setFormSubmitted(false);
      setSubmitLoad(false);

      dispatch(
        setThankYouData({
          page_name: projectDetail.project_title,
          document: projectDetail.document_other_data
            ? projectDetail.document_other_data
            : [],
        }),
      );

      Toast(response.message);

      // DELAY REDIRECT FOR DEBUGGING
      setTimeout(() => {
        router.push(`/${projectDetail.slug}/thankyou`);
      }, 5000);

      setInquiryObj({
        client_name: "",
        client_contact_no_display: "",
        client_contact_no: "",
        email_address: "",
        from_app: "true",
        master_user_id: "373",
        logged_in_master_user_id: "373",
        remarks: "",
        inquiry_from: "web",
        user_type: "N",
        flag: "https://flagcdn.com/w40/in.webp",
        country: "91",
        project_id: "",
      });
    } catch (error) {
      console.error("FORM SUBMIT ERROR:", error);
    } finally {
      console.timeEnd("Submit Process");
      console.groupEnd();
    }
  };

  useEffect(() => {
    const shouldLockScroll = isAmenityOpen || isProximityOpen;
    // const shouldLockScroll = isAmenityOpen;

    document.body.style.overflow = shouldLockScroll ? "hidden" : "auto";

    if (isAmenityOpen || isProximityOpen) {
      dispatch(setInquiryPopup(false));
    }

    //
    //

    return () => {
      document.body.style.overflow = "auto"; // cleanup on unmount
    };
    //   }, [inquiryPopup, isAmenityOpen, isProximityOpen]);
  }, [isAmenityOpen, isProximityOpen]);

  useEffect(() => {
    // let dataToUse;
    // let StaticData = {};
    // if (projectData && projectData.slug === slug) {
    //   dataToUse = projectData;
    //   StaticData = projectsArray.find(
    //     (p) => p.project_id == dataToUse.project_id
    //   );
    // } else {
    //   const allProjects = [...propertylist, ...completedPropertylist];
    //   dataToUse = allProjects.find((project) => project.slug === slug);
    //   StaticData = projectsArray.find(
    //     (p) => p.project_id == dataToUse.project_id
    //   );
    // }

    if (projectDetail) {
      let staticData = StaticData.find(
        (p) => p.project_id == projectDetail.project_id,
      );

      if (staticData) {
        setStaticprojectDetail(staticData);
      }

      let activeImage = "";
      if (
        projectDetail.gallery_data &&
        projectDetail.gallery_data[0] &&
        projectDetail.gallery_data[0].image &&
        projectDetail.gallery_data[0].image[0] &&
        projectDetail.gallery_data[0].image[0].title
      ) {
        activeImage = projectDetail.gallery_data[0].image[0].title;
      }
      setActiveImage(activeImage);
    }
  }, [projectDetail, propertylist, completedPropertylist]);

  const handleCountrySelect = (phonecode, flag) => {
    // dispatchInquiry({
    //   type: "SET_FULL_OBJECT",
    //   payload: {
    //     country: phonecode,
    //     flag: flag,
    //   },
    // });

    setInquiryObj({
      ...inquiryObj,
      country: phonecode,
      flag: flag,
    });
    setCountryFlag(false);
  };

  const loadCountry = async () => {
    try {
      //   const data = await CountryList();
      // Filter directly, without `await`
      //   const filtered = data.filter((country) => country.phonecode !== "92");
      //   setcountryList(filtered);
    } catch (err) {
      console.error("Error loading country data:", err);
    }
  };
  useEffect(() => {
    // loadCountry();
    // let fancyboxInstance;
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }

    // import("@fancyapps/ui").then(({ Fancybox }) => {
    //   fancyboxInstance = Fancybox.bind(
    //     "[data-fancybox=project-gallery-fancy]",
    //     {
    //       Carousel: {
    //         infinite: true,
    //       },
    //     }
    //   );

    // Fancybox.bind("[data-fancybox=project-gallery-fancy4]", {
    //   Carousel: {
    //     infinite: true,
    //   },
    // });
    // });
    return () => {
      //   import("@fancyapps/ui").then(({ Fancybox }) => {
      //     Fancybox.destroy();
      //   });
    };
  }, []);

  useEffect(() => {
    if (projectDetail) {
      //
      dispatch(setInquiryPopupObj(projectDetail));
    }
  }, [projectDetail, pathName]);

  // useEffect(() => {
  //   if (projectDetail) {
  //     dispatch(setInquiryPopupObj(projectDetail));
  //   }
  // }, [pathName]);

  const bottomStripRef = useRef(null);
  const floatingBtnRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const remainingDistance = documentHeight - (scrollTop + windowHeight);

      const bottomStrip = bottomStripRef.current;
      const floatingBtn = floatingBtnRef.current;

      if (!bottomStrip || !floatingBtn) return;

      if (scrollTop > 600 && remainingDistance > 600) {
        bottomStrip.classList.add("showStrip");
        floatingBtn.classList.add("active");
      } else if (scrollTop < 200) {
        bottomStrip.classList.remove("showStrip");
        floatingBtn.classList.remove("active");
      } else if (remainingDistance >= 600) {
        setTimeout(() => {
          bottomStrip.classList.add("showStrip");
          floatingBtn.classList.add("active");
        }, 100);
      }

      if (remainingDistance < 600) {
        setTimeout(() => {
          bottomStrip.classList.remove("showStrip");
          floatingBtn.classList.remove("active");
        }, 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  console.log(projectDetail);
  if (projectDetail) {
    return (
      <>
        {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}

        <div
          className="reecosys-main-wrapper reecosys-detail-wrapper"
          id="reecosys-main-wrapper"
          onClick={() => {
            setCountryFlag(false);
          }}
        >
          <div id="reecosys-detail-wrapper" className="relative">
            <section
              className={`reecosys-section reecosys-banner-section relative ${
                projectDetail.project_id == 722 ? "four-bhk-banner" : ""
              } `}
              id="reecosys-project-detail-section-1"
            >
              {projectDetail.banners_data != undefined &&
                projectDetail.banners_data.images.length > 0 && (
                  <div>
                    <Swiper spaceBetween={30} slidesPerView={1} loop>
                      {projectDetail.banners_data.images != undefined &&
                        projectDetail.banners_data.images.map(
                          (banner_data, index) => (
                            <SwiperSlide key={index}>
                              {banner_data?.image_web_full &&
                                projectDetail?.project_id != "801" && (
                                  <div className="project_banner_image relative overflow ">
                                    <img
                                      src={`${banner_data.image_web_full}&w=1980&q=100`}
                                      alt=""
                                      className=""
                                    />
                                  </div>
                                )}

                              {/* PROJECT ID 801 */}
                              {banner_data?.image_web_full &&
                                projectDetail?.project_id == "801" && (
                                  <div className="project_banner_image relative overflow">
                                    <img
                                      src={`${banner_data.image_web_full}&w=1980&q=100`}
                                      alt=""
                                      className="hide-tab-mobile"
                                    />
                                    <img
                                      src="/images/swatiSignia_pageBannerMobile.jpeg"
                                      alt=""
                                      className="visible-tab-mobile"
                                    />
                                  </div>
                                )}
                            </SwiperSlide>
                          ),
                        )}
                    </Swiper>
                  </div>
                )}
            </section>

            {
              // projectDetail.big_text_pain &&
              (projectDetail.highlights?.length > 0 ||
                projectDetail.rera_number != undefined ||
                projectDetail.document_data != undefined ||
                projectDetail.big_text_pain != undefined) && (
                <section
                  className="reecosys-section relative section-padding"
                  id="reecosys-project-detail-section-3"
                >
                  <div className="main-container">
                    <div className=" inner-flex inner-flex-small2">
                      <div className="inner-flex inner-flex-smallest">
                        {projectDetail.project_title && (
                          <div className="banner-title banner-title-border-div relative">
                            <h2
                              className=" uppercase"
                              data-aos="fade-in"
                              data-aos-duration="1000"
                              data-aos-delay="400"
                              dangerouslySetInnerHTML={{
                                __html: projectDetail.project_title,
                              }}
                            ></h2>
                            <div
                              className={`detail-status-lable status-lable status-${projectDetail.status
                                .toLowerCase()
                                .replace(/\s+/g, "-")
                                .replace(/[^a-z0-9-]/g, "")}`}
                            >
                              <p className="text-uppercase">
                                {projectDetail.status}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>

                      <div
                        className="new-detail-banner-abs-flex"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                        data-aos-delay="700"
                      >
                        <div className="inner-flex inner-flex-smallest">
                          <div className="new-detail-highlight-grid">
                            {projectDetail.highlights != undefined &&
                              projectDetail.highlights.length > 0 &&
                              projectDetail.highlights.map((data, index) => (
                                <div key={index}>
                                  <div className="section-paragraph">
                                    <p className="capitalize  semibold-fonts">
                                      {data.tag_line}
                                    </p>
                                  </div>
                                  <div className="section-paragraph">
                                    <p className="capitalize gray-color regular-fonts">
                                      {data.name}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            {projectDetail.rera_number && (
                              <div
                                style={{ flexBasis: "100%", opacity: "0.4" }}
                              >
                                <div className="section-paragraph">
                                  <p>
                                    <span className="primary-color bold-fonts">
                                      RERA :
                                    </span>
                                    {projectDetail.rera_number}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                          {projectDetail.big_text_pain && (
                            <div
                              className=" section-paragraph readmoreText detailReadMore"
                              data-aos="fade-in"
                              data-aos-duration="1000"
                              data-aos-delay="400"
                            >
                              <p>
                                <ReadMore
                                  text={projectDetail.big_text_pain}
                                  maxLength={0}
                                />
                              </p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className=""
                        data-aos="fade-in"
                        data-aos-duration="1000"
                        data-aos-delay="1100"
                      >
                        <ul className="flex-row  downloadDataFlex">
                          {/* <li className={`${isMobilescreen ? "w100" : ""}`}> */}
                          <li>
                            <button
                              className={`reecosys-template-button button-style-secondary w100`}
                              // ng-click=" inquire_popup_click(); inquiry_from_click(); "
                              onClick={() => {
                                (dispatch(setInquiryPopupObj(projectDetail)),
                                  dispatch(setInquiryPopup(true)));
                              }}
                            >
                              <span className="material-symbols-outlined">
                                chat
                              </span>
                              <p className="capitalize">Inquire Now</p>
                            </button>
                          </li>
                          {projectDetail.document_other_data != undefined &&
                            projectDetail.document_other_data.length > 0 &&
                            projectDetail.document_other_data
                              .filter(
                                (download_data) =>
                                  download_data.type == "Brochure",
                              )
                              .map((download_data, index) => (
                                <li key={index}>
                                  <button
                                    onClick={() => {
                                      (dispatch(
                                        setInquiryPopupObj(projectDetail),
                                      ),
                                        dispatch(setInquiryPopup(true)));
                                    }}
                                    className={`reecosys-template-button button-style-primary ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                  >
                                    <span className="material-symbols-outlined">
                                      download
                                    </span>
                                    <p className="capitalize">
                                      {isMobilescreen ? "" : "Download "}
                                      {download_data.type}
                                    </p>
                                  </button>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
              )
            }

            {projectDetail.project_id != "759" &&
              projectDetail.virtual_data != undefined &&
              projectDetail.virtual_data.length > 0 &&
              projectDetail.virtual_data
                .filter(
                  (video) => video.type === "walk-through" && video.image != "",
                )
                .map((video, index) => (
                  <section
                    key={index}
                    className="reecosys-section relative"
                    data-aos="fade-in"
                    data-aos-delay="400"
                    data-aos-duration="1000"
                    id="reecosys-project-detail-section-4"
                  >
                    <div className="main-container">
                      <div className="inner-flex inner-flex-medium inner-flex-center">
                        <div className="section-title">
                          {projectDetail.project_id != "763" &&
                            projectDetail.project_id != "764" && (
                              <h2
                                className="uppercase text-center"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                                data-aos-delay="300"
                              >
                                Sample House
                              </h2>
                            )}
                          {(projectDetail.project_id == "763" ||
                            projectDetail.project_id == "764") && (
                            <h2
                              className="uppercase text-center"
                              data-aos="fade-in"
                              data-aos-duration="1000"
                              data-aos-delay="300"
                            >
                              Walk-Through
                            </h2>
                          )}
                        </div>
                        <div className="walkthrough-project-thumb  relative">
                          <div
                            className="walk-thumbnail-image relative"
                            data-aos="fade-in"
                            data-aos-duration="1000"
                            data-aos-delay="600"
                          >
                            <WalkthroughVideo virtualDataArray={video.url} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ))}

            {projectDetail.project_id == "760" && (
              <div className="section-padding pb0">
                <section
                  className="reecosys-section relative "
                  data-aos="fade-in"
                  data-aos-delay="400"
                  data-aos-duration="1000"
                  id="reecosys-project-detail-section-4"
                >
                  <div className="main-container">
                    <div className="inner-flex inner-flex-medium inner-flex-center">
                      <div className="section-title">
                        <h2
                          className="uppercase text-center "
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="300"
                        >
                          Walk-Through
                        </h2>
                      </div>
                      <div className="walkthrough-project-thumb  relative">
                        <div
                          className="walk-thumbnail-image relative "
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="600"
                        >
                          <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/zdCbBrTOW5k?si=cTK_Q-8rXpbGfrKe?mute=0&loop=1&enablejsapi=1&controls=1&cc_load_policy=0" />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}

            {projectDetail.project_id == "767" && (
              <div className="section-padding pb0">
                <section
                  className="reecosys-section relative"
                  data-aos="fade-in"
                  data-aos-delay="400"
                  data-aos-duration="1000"
                >
                  <div className="main-container">
                    <div className="inner-flex inner-flex-medium inner-flex-center">
                      <div className="section-title">
                        <h2
                          className="uppercase text-center"
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="300"
                        >
                          Sample House
                        </h2>
                      </div>

                      <div className={` tab_buttons`}>
                        <button
                          onClick={() => {
                            setSelectedTab("3bhk");
                          }}
                          className={`${
                            selectedTab === "3bhk" ? "active_tab" : ""
                          }`}
                        >
                          3 BHK
                        </button>
                        <button
                          onClick={() => {
                            setSelectedTab("4bhk");
                          }}
                          className={`${
                            selectedTab === "4bhk" ? "active_tab" : ""
                          }`}
                        >
                          4 BHK
                        </button>
                      </div>

                      <div className="tab-content w100">
                        {selectedTab === "3bhk" && (
                          <div>
                            <div className="walkthrough-project-thumb relative">
                              <div
                                className="walk-thumbnail-image relative "
                                data-aos="fade-in"
                                data-aos-duration="1000"
                                data-aos-delay="600"
                              >
                                <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/q9lEBF_N3B8?mute=0&loop=1&enablejsapi=1&controls=1&cc_load_policy=0"></WalkthroughVideo>
                              </div>
                            </div>
                          </div>
                        )}

                        {selectedTab === "4bhk" && (
                          <div>
                            <div className="walkthrough-project-thumb relative">
                              <div
                                className="walk-thumbnail-image relative "
                                data-aos="fade-in"
                                data-aos-duration="1000"
                                data-aos-delay="600"
                              >
                                <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/7-UBgFTc_NI?mute=0&loop=1&enablejsapi=1&controls=1&cc_load_policy=0"></WalkthroughVideo>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}

            {projectDetail.project_id == "759" && (
              <div className="section-padding pb0">
                <section
                  className="reecosys-section relative "
                  data-aos="fade-in"
                  data-aos-delay="400"
                  data-aos-duration="1000"
                >
                  <div className="main-container">
                    <div className="inner-flex inner-flex-medium inner-flex-center">
                      <div className="section-title">
                        <h2
                          className="uppercase text-center"
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="300"
                        >
                          Sample House
                        </h2>
                      </div>
                      <div className={` tab_buttons`}>
                        <button
                          onClick={() => {
                            setSelectedTab("3bhk");
                          }}
                          className={`${
                            selectedTab === "3bhk" ? "active_tab" : ""
                          }`}
                        >
                          3 BHK
                        </button>
                        <button
                          onClick={() => {
                            setSelectedTab("4bhk");
                          }}
                          className={`${
                            selectedTab === "4bhk" ? "active_tab" : ""
                          }`}
                        >
                          4 BHK
                        </button>
                      </div>

                      <div className="tab-content w100">
                        {selectedTab === "3bhk" && (
                          <div>
                            <div className="walkthrough-project-thumb relative">
                              <div
                                className="walk-thumbnail-image relative "
                                data-aos="fade-in"
                                data-aos-duration="1000"
                                data-aos-delay="600"
                              >
                                <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/7o-o3ND2TV8?si=1hma7wQDpy50TZaw?mute=0&loop=1&enablejsapi=1&controls=1"></WalkthroughVideo>
                              </div>
                            </div>
                          </div>
                        )}

                        {selectedTab === "4bhk" && (
                          <div>
                            <div className="walkthrough-project-thumb relative">
                              <div
                                className="walk-thumbnail-image relative "
                                data-aos="fade-in"
                                data-aos-duration="1000"
                                data-aos-delay="600"
                              >
                                <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/_gPcnLJa_CY?si=IGuQJRyAK9Bf2RM6?mute=0&loop=1&enablejsapi=1&controls=1"></WalkthroughVideo>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}

            {projectDetail.project_id == "767" && (
              <div className="section-padding pb0">
                <section
                  className="reecosys-section relative"
                  data-aos="fade-in"
                  data-aos-delay="400"
                  data-aos-duration="1000"
                  id="reecosys-project-detail-section-4"
                >
                  <div className="main-container">
                    <div className="inner-flex inner-flex-medium inner-flex-center">
                      <div className="section-title">
                        <h2
                          className="uppercase text-center"
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="300"
                        >
                          Walk-Through
                        </h2>
                      </div>
                      <div className="walkthrough-project-thumb  relative">
                        <div
                          className="walk-thumbnail-image relative aos fadeIn"
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="600"
                        >
                          <WalkthroughVideo virtualDataArray="https://www.youtube.com/embed/9kWq2NVTK-w?si=R5mc4SXgRdL3m0h8?mute=0&loop=1&enablejsapi=1&controls=1"></WalkthroughVideo>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}

            {projectDetail.gallery_data != undefined &&
              projectDetail.gallery_data[0].image != undefined &&
              projectDetail.gallery_data[0].image.length > 0 && (
                <section
                  id="reecosys-project-detail-section-5"
                  style={{ minHeight: "75vh" }}
                  className="section-padding reecosys-section"
                >
                  {projectDetail.gallery_data.map((gallery, index) => (
                    <div key={index} id="reecosys-detail-section-gallery">
                      <div className="inner-flex inner-flex-small">
                        <div className="main-container">
                          <div
                            className="flex-row w100mob alc j-c-c relative "
                            data-aos="fade-top"
                            data-aos-duration="1000"
                            data-aos-delay="400"
                          >
                            {(gallery.title || gallery.tag_line) && (
                              <div className="w100mob relative">
                                <div className="inner-flex inner-flex-smallest inner-flex-center w100mob">
                                  <div className="section-title uppercase relative">
                                    <h2
                                      data-aos="fade-in"
                                      data-aos-duration="1000"
                                      data-aos-delay="300"
                                    >
                                      Images
                                    </h2>
                                  </div>
                                  {projectDetail.project_id == 761 && (
                                    <div className="flex-row gallery-tab-images alc j-c-c inner-flex-smallest actualClickPara">
                                      <p
                                        onClick={() => {
                                          setActiveImage("Actual");
                                          setShowNextImages(false);
                                        }}
                                        className={` ${
                                          activeImage == "Actual"
                                            ? "active"
                                            : ""
                                        } `}
                                      >
                                        Actual Image
                                      </p>
                                      <p
                                        onClick={() => {
                                          setActiveImage("3D");
                                          setShowNextImages(false);
                                        }}
                                        className={` ${
                                          activeImage == "3D" ? "active" : ""
                                        } `}
                                      >
                                        3D Image
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* <div className="main-container">
                          <div>
                            <div className="gallery-image-grid">
                              {gallery.image != undefined &&
                                gallery.image.map((gallaryImgData, index) => {
                                  const shouldShow = (() => {
                                    if (activeImage === "") {
                                      return index < 6;
                                    } else if (activeImage === "Actual") {
                                      return index < 6;
                                    } else if (activeImage === "3D") {
                                      return index >= 6 && index <= 11;
                                    } else {
                                      return false;
                                    }
                                  })();

                                  if (!shouldShow) return null;

                                  let sizeParam = "";
                                  switch (index) {
                                    case 0:
                                    case 5:
                                    case 11:
                                      sizeParam = "&w=888&q=100";
                                      break;
                                    case 1:
                                      sizeParam = "&w=520&q=100";
                                      break;
                                    case 2:
                                    case 3:
                                    case 8:
                                    case 9:
                                      sizeParam = "&h=432&q=100";
                                      break;
                                    case 4:
                                    case 10:
                                      sizeParam = "&h=794&q=100";
                                      break;
                                    case 6:
                                    case 7:
                                      sizeParam = "&w=888&q=100";
                                      break;
                                    default:
                                      sizeParam = "&w=888&q=100";
                                  }

                                  return (
                                    <div
                                      className="image-item relative"
                                      key={index}
                                    >
                                      <a
                                        data-fancybox="project-gallery-fancy"
                                        href={gallaryImgData.image_full}
                                        className="project-gallery-fancy relative"
                                        target="_self"
                                      >
                                        <img
                                          loading="lazy"
                                          src={`${gallaryImgData.image}${sizeParam}`}
                                          alt={projectDetail.size_price}
                                          className="image-cover lazyload shimer-block"
                                          data-aos="fade-in"
                                          data-aos-duration="1000"
                                          data-aos-delay={`0.${index * 3}s`}
                                        />
                                        <div className="project-glaery-overlay"></div>
                                        <div className="project-enlarge-icons-galeery">
                                          <span className="material-symbols-outlined">
                                            pan_zoom
                                          </span>
                                        </div>
                                      </a>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div> */}

                        <div className="main-container">
                          <div>
                            <div className="gallery-image-grid">
                              {gallery.image !== undefined &&
                                gallery.image.map((gallaryImgData, index) => {
                                  const shouldShow = (() => {
                                    if (activeImage === "") {
                                      return index < 6;
                                    } else if (activeImage === "Actual") {
                                      return index < 6;
                                    } else if (activeImage === "3D") {
                                      return index >= 6 && index <= 11;
                                    } else {
                                      return false;
                                    }
                                  })();

                                  if (!shouldShow) return null; // Only grid images here

                                  let sizeParam = "";
                                  switch (index) {
                                    case 0:
                                    case 5:
                                    case 11:
                                      sizeParam = "&w=888&q=100";
                                      break;
                                    case 1:
                                      sizeParam = "&w=520&q=100";
                                      break;
                                    case 2:
                                    case 3:
                                    case 8:
                                    case 9:
                                      sizeParam = "&h=432&q=100";
                                      break;
                                    case 4:
                                    case 10:
                                      sizeParam = "&h=794&q=100";
                                      break;
                                    case 6:
                                    case 7:
                                      sizeParam = "&w=888&q=100";
                                      break;
                                    default:
                                      sizeParam = "&w=888&q=100";
                                  }

                                  return (
                                    <div
                                      className="image-item relative"
                                      key={index}
                                    >
                                      <a
                                        data-fancybox="project-gallery-fancy"
                                        href={gallaryImgData.image_full}
                                        className="project-gallery-fancy relative"
                                        target="_self"
                                      >
                                        <img
                                          loading="lazy"
                                          src={`${gallaryImgData.image}${sizeParam}`}
                                          alt={projectDetail.size_price}
                                          className="image-cover lazyload shimer-block"
                                          data-aos="fade-in"
                                          data-aos-duration="1000"
                                          data-aos-delay={`0.${index * 3}s`}
                                        />
                                        <div className="project-glaery-overlay"></div>
                                        <div className="project-enlarge-icons-galeery">
                                          <span className="material-symbols-outlined">
                                            pan_zoom
                                          </span>
                                        </div>
                                      </a>
                                    </div>
                                  );
                                })}
                            </div>

                            {/* Hidden Fancybox links (for the rest of the images) */}
                            <div style={{ display: "none" }}>
                              {gallery.image !== undefined &&
                                gallery.image.map((gallaryImgData, index) => {
                                  const shouldShow = (() => {
                                    if (activeImage === "") {
                                      return index < 6;
                                    } else if (activeImage === "Actual") {
                                      return index < 6;
                                    } else if (activeImage === "3D") {
                                      return index >= 6 && index <= 11;
                                    } else {
                                      return false;
                                    }
                                  })();

                                  if (shouldShow) return null; // Exclude already-visible ones

                                  return (
                                    <a
                                      key={index}
                                      data-fancybox="project-gallery-fancy"
                                      href={gallaryImgData.image_full}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        </div>

                        <div className="main-container">
                          <div className="btns-midflex-detail ">
                            {gallery.image != undefined &&
                              gallery.image.map((gallaryImgData, index) => (
                                <a
                                  key={index}
                                  href={gallaryImgData.image_full}
                                  data-fancybox="project-gallery-fancy4"
                                  target="_self"
                                  style={{
                                    display: index === 0 ? "block" : "none",
                                  }}
                                >
                                  <button
                                    className={`reecosys-template-button button-style-primary-outline  ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                    data-aos="fade-top"
                                    data-aos-duration="1000"
                                    data-aos-delay="400"
                                  >
                                    <span className="material-symbols-outlined">
                                      photo_library
                                    </span>
                                    <p>View All Images</p>
                                  </button>
                                </a>
                              ))}

                            {projectDetail.amenities_data != undefined &&
                              projectDetail.amenities_data.length > 0 && (
                                <div className="">
                                  <button
                                    className={`reecosys-template-button button-style-primary-outline  ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                    data-aos="fade-top"
                                    data-aos-duration="1000"
                                    data-aos-delay="800"
                                    onClick={() => {
                                      dispatch(
                                        setAmenityToggle(!isAmenityOpen),
                                      );
                                    }}
                                  >
                                    <span className="material-symbols-outlined">
                                      category
                                    </span>
                                    <p className="capitalize">Amenities</p>
                                  </button>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </section>
              )}

            {projectDetail.map_iframe != undefined &&
              projectDetail.map_iframe != "" && (
                <section
                  className="reecosys-section section-padding relative"
                  id="reecosys-project-detail-section-8"
                >
                  <div className="inner-flex inner-flex-medium">
                    <div className="main-container" id="project_location">
                      <div className="">
                        {projectDetail.location_title != undefined && (
                          <div
                            className="inner-flex"
                            data-aos="fade-top"
                            data-aos-duration="1000"
                            data-aos-delay="400"
                          >
                            <div className="lcoation-view-grid-swati">
                              <div className="inner-flex inner-flex-medium">
                                <div className="section-title">
                                  <h2 className="uppercase">Location</h2>
                                </div>
                                <div className="inner-flex inner-flex-small">
                                  <div
                                    className="inner-flex inner-flex-smallest"
                                    data-aos="fade-top"
                                    data-aos-duration="1000"
                                    data-aos-delay="500"
                                  >
                                    <div className="flex-row alc section-paragraph">
                                      <span
                                        className="locationIcon"
                                        style={{
                                          alignSelf: "start",
                                          paddingTop: "5px",
                                        }}
                                      >
                                        <img
                                          loading="lazy"
                                          src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/MapPinArea.svg"
                                          alt="Map ICon"
                                        />
                                      </span>
                                      <p
                                        className="gray-color  location-50"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            projectDetail.address_description,
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                  <div className="flex-row alc locationFlex">
                                    <div
                                      className="inner-flex inner-flex-smallest "
                                      data-aos="fade-top"
                                      data-aos-duration="1000"
                                      data-aos-delay="600"
                                    >
                                      <div className="flex-row alc section-paragraph">
                                        <span className="locationIcon">
                                          <img
                                            loading="lazy"
                                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/EnvelopeOpen.svg"
                                            alt="Email Icon"
                                          />
                                        </span>
                                        <p className="gray-color">
                                          <a
                                            href={`mailto:${projectDetail.project_contact_email || "info@swatiprocon.com"}`}
                                            className="hover-color-link"
                                          >
                                            {projectDetail.project_contact_email ||
                                              "info@swatiprocon.com"}
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="inner-flex inner-flex-smallest "
                                      data-aos="fade-top"
                                      data-aos-duration="1000"
                                      data-aos-delay="700"
                                    >
                                      <div className="flex-row alc section-paragraph">
                                        <span className="locationIcon">
                                          <img
                                            loading="lazy"
                                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/PhoneCall.svg"
                                            alt="Call Icon"
                                          />
                                        </span>
                                        <p className="gray-color">
                                          <a
                                            href={`tel:${projectDetail.project_contact_no || "+91 99090 40084"}`}
                                            className="hover-color-link"
                                          >
                                            {projectDetail.project_contact_no ||
                                              "+91 99090 40084"}
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row flex-col-mob alc">
                                  <div
                                    className={`altura-btn altura-filled-btn-black ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                    data-aos="fade-top"
                                    data-aos-duration="1000"
                                    data-aos-delay="800 "
                                  >
                                    <a
                                      // href="https://maps.app.goo.gl/fiBBova9ydoAXER29"
                                      href={staticProjectDetail?.locationLink}
                                      style={{ display: "block" }}
                                      target="_blank"
                                      className={`${
                                        isMobilescreen ? "w100" : ""
                                      } `}
                                    >
                                      <button
                                        className={`reecosys-template-button button-style-primary ${
                                          isMobilescreen ? "w100" : ""
                                        } `}
                                      >
                                        <span className="material-symbols-outlined">
                                          near_me
                                        </span>
                                        <p className=""> View on Map </p>
                                      </button>
                                    </a>
                                  </div>
                                  {staticProjectDetail?.proximityData !=
                                    undefined &&
                                    staticProjectDetail?.proximityData.length >
                                      0 && (
                                      <button
                                        className={`reecosys-template-button button-style-primary-outline ${
                                          isMobilescreen ? "w100" : ""
                                        } `}
                                        onClick={() => {
                                          dispatch(setProximityToggle(true));
                                        }}
                                      >
                                        <span className="material-symbols-outlined">
                                          location_city
                                        </span>
                                        <p>View Proximities</p>
                                      </button>
                                    )}
                                </div>
                              </div>
                              {projectDetail.map_iframe != undefined && (
                                <div
                                  data-aos="fade-in"
                                  data-aos-duration="1000"
                                  data-aos-delay="500"
                                >
                                  <div className="detail-location-iframe ">
                                    <iframe
                                      src={projectDetail.map_iframe}
                                      allowFullScreen=""
                                      loading="lazy"
                                      referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}

            <section className="inquiry-form-section section-padding">
              <div className="mini-container">
                <div
                  className="reecosys-section"
                  id="reecosys-detail-section-get-touch"
                >
                  <div className="inquiry_form_detail">
                    <div>
                      <div className="inner-flex inner-flex-medium">
                        <div className="inner-flex inner-flex-center inner-flex-smallest">
                          <div className="section-title">
                            <h2 className="semibold-fonts">Inquire Now</h2>
                          </div>
                          <div className="section-content">
                            <p>Fill your latest details.</p>
                          </div>
                        </div>
                        <div
                          className=" project_detail_inquiry_form"
                          data-aos="fade-in"
                          data-aos-duration="1000"
                          data-aos-delay="600"
                        >
                          <form
                            id="inquiry_form_detail"
                            name="inquiry_form_detail"
                            className="inner-flex"
                            onSubmit={handleSubmit}
                          >
                            <div className="form_wrapper">
                              <div className="contact_lable">
                                <span className="material-symbols-outlined icon-form-control">
                                  person
                                </span>
                                <input
                                  id="client_name"
                                  name="client_name"
                                  type="text"
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.client_name
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  } ${
                                    errors.client_name
                                      ? "ng-invalid "
                                      : "ng-valid"
                                  } ${
                                    inquiryObj.client_name ? "ng-touched" : ""
                                  } ${
                                    formSubmitted &&
                                    (!inquiryObj.client_name ||
                                      errors.client_name)
                                      ? "error"
                                      : ""
                                  } `}
                                  value={inquiryObj.client_name}
                                  onChange={handleChange}
                                  tabIndex={1}
                                />
                                <label
                                  className="md-lable"
                                  htmlFor="client_name"
                                >
                                  Name
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="contact_lable  relative">
                                <span className="material-symbols-outlined icon-form-control">
                                  dialpad
                                </span>
                                <input
                                  tabIndex={2}
                                  id="client_contact_no_display"
                                  name="client_contact_no_display"
                                  type="text"
                                  className={`form-control contact-form form-control-iconpad ${
                                    inquiryObj.client_contact_no_display
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  } ${
                                    formSubmitted &&
                                    (!inquiryObj.client_contact_no_display ||
                                      errors.client_contact_no_display)
                                      ? "error"
                                      : ""
                                  }
                                                                    ${
                                                                      !errors.client_contact_no_display &&
                                                                      inquiryObj
                                                                        .client_contact_no_display
                                                                        .length ===
                                                                        10
                                                                        ? "ng-valid"
                                                                        : "ng-invalid"
                                                                    } ${
                                                                      inquiryObj.client_contact_no_display
                                                                        ? "ng-touched"
                                                                        : ""
                                                                    }`}
                                  value={inquiryObj.client_contact_no_display}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  minLength="10"
                                  maxLength="10"
                                />
                                <label
                                  className="md-lable contact_code"
                                  htmlFor="contact_no"
                                >
                                  Mobile Number
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                                <div className="conatct_number_input">
                                  <div
                                    className="country_code_data"
                                    onClick={(event) => {
                                      setCountryFlag(true);
                                      event.stopPropagation();
                                    }}
                                    ng-click="country_code_click(); $event.stopPropagation();"
                                  >
                                    <div className="contact_country_flag">
                                      <img
                                        loading="lazy"
                                        src={inquiryObj.flag}
                                        alt="reecosys"
                                      />
                                    </div>
                                    <div>&nbsp;+{inquiryObj.country}</div>
                                    <div>
                                      <i
                                        className="fa fa-angle-down"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`country_code_list_data ${
                                    countryFlag ? "active" : ""
                                  } `}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="search_c-code">
                                    <input
                                      type="text"
                                      value={search}
                                      onChange={(e) =>
                                        setSearch(e.target.value)
                                      }
                                      placeholder="Search"
                                    />
                                  </div>
                                  <ul>
                                    {countryList != undefined &&
                                      countryList.length > 0 &&
                                      countryList
                                        .filter(
                                          (item) =>
                                            item.phonecode
                                              .toString()
                                              .includes(search) ||
                                            item.nicename
                                              .toLowerCase()
                                              .includes(search.toLowerCase()),
                                        )
                                        .map((item, index) => (
                                          <li
                                            key={`${item.phonecode}-${item.nicename}-${index}`}
                                          >
                                            <div
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleCountrySelect(
                                                  item.phonecode,
                                                  item.flag,
                                                );
                                              }}
                                            >
                                              <div>
                                                <img
                                                  src={item.flag}
                                                  alt="country"
                                                />
                                              </div>
                                              <span className="display_country_code">
                                                +{item.phonecode}
                                              </span>{" "}
                                              {item.nicename}
                                            </div>
                                          </li>
                                        ))}
                                  </ul>
                                </div>
                              </div>
                              <div className="contact_lable">
                                <span className="material-symbols-outlined icon-form-control">
                                  alternate_email
                                </span>
                                <input
                                  id="email_address"
                                  name="email_address"
                                  type="email"
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.email_address
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  }
                                                                     ${
                                                                       formSubmitted &&
                                                                       (!inquiryObj.email_address ||
                                                                         errors.email_address)
                                                                         ? "error"
                                                                         : ""
                                                                     }
                                                                     ${
                                                                       errors.email_address
                                                                         ? "ng-invalid"
                                                                         : "ng-valid"
                                                                     } ${
                                                                       inquiryObj.email_address
                                                                         ? "ng-touched"
                                                                         : ""
                                                                     }`}
                                  value={inquiryObj.email_address}
                                  onChange={handleChange}
                                  tabIndex={3}
                                />

                                <label
                                  className="md-lable"
                                  htmlFor="email_address"
                                >
                                  Email
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="contact_lable commentbox">
                                <span className="material-symbols-outlined icon-form-control">
                                  chat_bubble
                                </span>
                                <textarea
                                  id="remarks"
                                  name="remarks"
                                  type="text"
                                  // className={`form-control form-control-iconpad ${
                                  //   inquiryObj.remarks
                                  //     ? "ng-not-empty"
                                  //     : "ng-empty"
                                  // } ${inquiryObj.remarks ? "ng-touched" : ""}`}
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.remarks
                                      ? "ng-not-empty ng-touched"
                                      : "ng-empty"
                                  }`}
                                  value={inquiryObj.remarks}
                                  onChange={handleChange}
                                  rows="1"
                                  tabIndex={4}
                                ></textarea>

                                <label className="md-lable" htmlFor="remark">
                                  Comments
                                </label>
                              </div>
                              <p style={{ width: "100%" }}>
                                By submitting this form, you agree to the{" "}
                                <a href="#" className="hover-color-link">
                                  Terms & Conditions
                                </a>{" "}
                                of Swati Procon.
                              </p>
                              <div className="sunmit-project-btn">
                                <button
                                  className="reecosys-template-button button-style-primary"
                                  type="submit"
                                  tabIndex={5}
                                >
                                  <span className="material-symbols-outlined">
                                    send
                                  </span>
                                  {submitLoad ? (
                                    <p>Please Wait...</p>
                                  ) : (
                                    <p>Submit</p>
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {projectDetail?.project_id == "801" && (
              <section
                className="reecosys-section section-padding-small relative"
                style={{ backgroundColor: "var(--background-gray)" }}
              >
                <div className="tata-capital-svg">
                  <img src="/images/tata-capital.svg" alt="" />
                </div>
              </section>
            )}
          </div>
        </div>

        <div
          className={`click-overlay ${
            isAmenityOpen || isProximityOpen ? "active" : ""
          } `}
          onClick={() => {
            (dispatch(setAmenityToggle(false)),
              dispatch(setProximityToggle(false)));
          }}
        ></div>
        <div className={`amenities_popup ${isAmenityOpen ? "active" : ""}`}>
          <div className="relative">
            <div
              className="amenities-close-icon"
              onClick={() => {
                dispatch(setAmenityToggle(false));
              }}
            >
              <span className="material-symbols-outlined">close</span>
            </div>
            <div className="all-amenities-grid-detail inner-flex inner-flex-medium">
              <div className="">
                <div className="section-title">
                  <h2>Amenities</h2>
                </div>
              </div>
              <div className="all-amenites-list">
                <ul>
                  {projectDetail.amenities_data &&
                    projectDetail.amenities_data.length > 0 &&
                    projectDetail.amenities_data.map((amenities, index) => (
                      <li key={index} className="flex-row alc">
                        <div className="amenities-icon ">
                          <img
                            src={amenities.icon}
                            loading="lazy"
                            alt={projectDetail.project_title}
                          />
                        </div>
                        <div className="amenities-text">
                          <p>{amenities.amenity}</p>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`amenities_popup proximities_popup ${isProximityOpen ? "active" : ""}`}
        >
          <div className="relative">
            <div
              className="amenities-close-icon"
              onClick={() => {
                dispatch(setProximityToggle(false));
              }}
            >
              <span className="material-symbols-outlined">close</span>
            </div>
            <div className="all-amenities-grid-detail inner-flex inner-flex-medium">
              <div className="">
                <div className="section-title">
                  <h2>Proximities</h2>
                </div>
              </div>
              <div className="proximity-list">
                <ul>
                  {staticProjectDetail?.proximityData &&
                    staticProjectDetail?.proximityData.length > 0 &&
                    staticProjectDetail?.proximityData.map(
                      (proximity, index) => (
                        <li key={index} className="flex-row  alc">
                          <div className="section-subtitle">
                            <h4>{proximity.minutes}</h4>
                          </div>
                          <div className="section-content">
                            <p>
                              Minutes drive to
                              {proximity.location}
                            </p>
                          </div>
                        </li>
                      ),
                    )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <BottomStrip
          isAmenityActive={isAmenityOpen}
          isProximityActive={isProximityOpen}
          isMobilescreen={isMobilescreen}
          projectDetail={projectDetail}
        /> */}
      </>
    );
  } else {
    return <h1>Please Wait</h1>;
  }
}
